import { render, staticRenderFns } from "./VideoBlock.vue?vue&type=template&id=ede45f62&scoped=true&"
import script from "./VideoBlock.vue?vue&type=script&lang=js&"
export * from "./VideoBlock.vue?vue&type=script&lang=js&"
import style0 from "./VideoBlock.vue?vue&type=style&index=0&id=ede45f62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede45f62",
  null
  
)

export default component.exports